import Multiselect from 'multiselect-react-dropdown';
import PropTypes from 'prop-types';
import { PROJECT_CATEGORIES } from '../../config/constants';
import './ProjectFilters.css';

const ProjectFilters = ({
  typeFilter,
  onTypeFilterChange,
  languageFilter,
  uniqueTechCategories,
  onLanguageFilterChange
}) => {

  return (
    <div className="project-filters" role="group" aria-label="Project filters">
      <div className="filter-group">
        <label htmlFor="category-filter" className="filter-label">
          Filter by Category
        </label>
        <select
          id="category-filter"
          value={typeFilter}
          onChange={(e) => onTypeFilterChange(e.target.value)}
          aria-label="Filter projects by category"
          className="filter-select"
        >
          <option value={PROJECT_CATEGORIES.ALL}>All</option>
          <option value={PROJECT_CATEGORIES.ML}>ML</option>
          <option value={PROJECT_CATEGORIES.FULL_STACK}>Full Stack</option>
          <option value={PROJECT_CATEGORIES.IOT}>IoT</option>
          <option value={PROJECT_CATEGORIES.OTHER}>Other</option>
        </select>
      </div>
      <div className="filter-select">
        <Multiselect
          options={uniqueTechCategories.map((tech) => ({ name: tech }))}
          selectedValues={languageFilter.map((tech) => ({ name: tech }))}
          onSelect={(selectedList) => {
            const selectedTechs = selectedList.map((item) => item.name); 
            onLanguageFilterChange(selectedTechs);
          }}
          onRemove={(selectedList) => {
            const selectedTechs = selectedList.map((item) => item.name); 
            onLanguageFilterChange(selectedTechs); 
          }}
          displayValue="name"
        />
      </div>
    </div>
  );
};

ProjectFilters.propTypes = {
  typeFilter: PropTypes.string.isRequired,
  onTypeFilterChange: PropTypes.func.isRequired,
  languageFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
  uniqueTechCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  onLanguageFilterChange: PropTypes.func.isRequired,
};


export default ProjectFilters;

